import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
} from '@unreserved-frontend-v2/api/generated/graphql/types'

export const yearBuilt = (details: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails) => {
  const { buildYear, buildYearMax, buildYearMin } = details

  if (!buildYear && !buildYearMin && !buildYearMax) {
    return null
  }

  if (buildYear) {
    return buildYear
  }

  if (!buildYearMax && buildYearMin) {
    return buildYearMin.toString()
  }

  if (buildYearMax && !buildYearMin) {
    return buildYearMax.toString()
  }

  if (buildYearMin === buildYearMax) {
    return buildYearMin?.toString()
  }

  return `${buildYearMin} - ${buildYearMax}`
}
